// @ts-expect-error $hasDep is untyped
export const ContentComponentWithDnDCompat = $hasDep('react-dnd', '5') ?
// eslint-disable-next-line
require('./ContentComponentWithDnDLatest').ContentComponentWithDnDLatest :
// eslint-disable-next-line
require('./ContentComponentWithDnDLegacy').ContentComponentWithDnDLegacy;